<!--
 * @Author: your name
 * @Date: 2020-06-16 08:53:23
 * @LastEditTime: 2020-06-17 10:59:41
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\components\basics\no-data.vue
-->
// 接收
<template>
  <div class="nodata">
    <div class="imgPart">
    <img src="../../assets/vacant_nodata.png" />
    <p>{{stringTip}}<router-link :to="address">
        {{routerDes}}
      </router-link>
    </p>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    stringTip: {
      type: String,
      default: '暂无数据'
    },
    address: {
      type: Object,
      default: () => {
        return {
          name: 'login'
        }
      }
    },
    routerDes: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // stringTip: '暂无数据'
    }
  },
  created () {
  },
  methods: {
  },
  watch: {
  },
  computed: {
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
  .nodata {
    width: 100%;
    text-align: center;
    /* margin-top:14%; */
  }

  .nodata p a {
    cursor: pointer;
    text-decoration: none;
    color: $green2;
  }

  p {
    color:$grey99;
  }

  img {
    width: 200px;
    margin: 46% 0 0 0;
  }
</style>
